import React, { useEffect, useState } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ReactComponent as SvgDotPatternIcon } from "../../images/dot-pattern.svg";
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";

const API_URL = process.env.REACT_APP_IS_PROD == "true" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV



const Container = tw.div`relative`;
const SingleColumn = tw.div`max-w-screen-xl mx-auto py-10 lg:py-12`;
const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const HeadingDescription = tw.p`mt-4 font-medium text-gray-600 text-center max-w-sm`;
const Content = tw.div`mt-16`;
const Card = styled.div((props) => [
  tw`mt-24 md:flex justify-center items-center`,
  props.reversed ? tw`flex-row-reverse` : "flex-row",
]);

const CarouselContainer = styled.div`
  ${tw`rounded md:w-1/2 lg:w-5/12 xl:w-1/3 flex-shrink-0 mx-4 sm:mx-8 md:mx-4 lg:mx-8`}
`;

const Image = styled.div`
  ${tw`h-80 md:h-144 bg-cover bg-center rounded`}
  background-image: ${({ image }) => `url(${image})`};
`;

const Details = tw.div`mt-4 md:mt-0 md:max-w-md mx-4 sm:mx-8 md:mx-4 lg:mx-8`;
const Subtitle = tw.div`font-bold tracking-wide text-[#0049AC]`;
const Title = tw.h4`text-3xl font-bold text-gray-900`;
const Description = tw.p`mt-2 text-sm leading-loose`;
const Link = tw.a`inline-block mt-4 text-sm text-[#0049AC] font-bold cursor-pointer transition duration-300 border-b-2 border-transparent hover:border-[#0049AC]`;

const SvgDotPattern1 = tw(SvgDotPatternIcon)`absolute top-0 left-0 transform -translate-x-20 rotate-90 translate-y-8 -z-10 opacity-25 text-[#0049AC] fill-current w-24`;

export default () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const dummyData = [
    {
      images: [
        "https://images.unsplash.com/photo-1550699026-4114bbf4fb49?ixlib=rb-1.2.1&auto=format&fit=crop&w=632&q=80",
        "https://images.unsplash.com/photo-1543423924-b9f161af87e4?ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80",
      ],
      type: "Paid",
      name: "Loachella, NYC",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      event_date: "01-02-2000",
    },
    {
      images: [
        "https://images.unsplash.com/photo-1509824227185-9c5a01ceba0d?ixlib=rb-1.2.1&auto=format&fit=crop&w=658&q=80",
        "https://images.unsplash.com/photo-1550699026-4114bbf4fb49?ixlib=rb-1.2.1&auto=format&fit=crop&w=632&q=80",
      ],
      type: "Free",
      name: "Rock In Rio, Upstate",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      event_date: "01-02-2000",
    },
  ];

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(`${API_URL}/web/events/event-list`, {
          headers: {
            'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
          }
        });
        if (response.ok) {
          const result = await response.json();
          setEvents(result.data.length > 0 ? result.data : dummyData);
        }
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchEvents();
  }, []);

  if (loading) {
    return <p tw="text-center">Loading events...</p>;
  }

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  return (
    <Container>
      <SingleColumn>
        <HeadingInfoContainer>
          <HeadingTitle>Popular Events @ Traviator Holidays</HeadingTitle>
          <HeadingDescription>
            Here are some of the event and activities organised by Traviator Holidays.
          </HeadingDescription>
        </HeadingInfoContainer>
        <Content>
          {events.map((event, i) => (
            <Card key={i} reversed={i % 2 === 1}>
              <CarouselContainer>
                <Slider {...sliderSettings}>
                  {event.images.map((img, idx) => (
                    <Image key={idx} image={img} />
                  ))}
                </Slider>
              </CarouselContainer>
              <Details>
                <Subtitle>{event.type}</Subtitle>
                <Title>{event.name}</Title>
                <Description>{event.description}</Description>
                <Link>
                  {new Date(event.event_date).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  }).replace(",", "")}
                </Link>
              </Details>
            </Card>
          ))}
        </Content>
      </SingleColumn>
      <SvgDotPattern1 />
    </Container>
  );
};
